import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface TemplateGridShellProps {
  templateLabel: string;
  rowCount: number;
  className?: string;
  controls?: ReactNode;
  showHeader?: boolean;
  children: ReactNode;
}

export function TemplateGridShell({
  templateLabel,
  rowCount,
  className,
  controls,
  showHeader = true,
  children,
}: TemplateGridShellProps) {
  return (
    <div className={cn("space-y-2", className)}>
      {showHeader && (
        <div className="flex items-center justify-between gap-3 border-b pb-2">
          <div className="flex items-center gap-3">
            <Badge variant="outline">
              {templateLabel}
            </Badge>
            <span className="text-sm text-muted-foreground">{rowCount} rows</span>
          </div>
          {controls}
        </div>
      )}
      {children}
    </div>
  );
}
